import type { Action } from 'state/actions';
import { addKey, patchKey, removeKey } from 'state/utils/collection';

import type { TradeMap } from './trade.model';
import { initialTradeMap } from './trade.model';

export function tradeReducer(state: TradeMap = initialTradeMap, action: Action): TradeMap {
  switch (action.type) {
    case 'SECONDARY_MARKET_TRADE_REQUESTED':
      return addKey(state, action.quoteId, { status: 'PENDING' });
    case 'SECONDARY_MARKET_TRADE_FAILED':
      return patchKey(state, action.quoteId, () => ({ status: 'FAILED' as const }));
    case 'SECONDARY_MARKET_TRADE_REJECTED':
      return patchKey(state, action.quoteId, () => ({ status: 'REJECTED' as const }));
    case 'SECONDARY_MARKET_TRADE_RECEIVED':
      return patchKey(state, action.quoteId, () => ({ status: 'DONE' as const, tradeDate: action.tradeDate }));
    case 'SECONDARY_MARKET_QUOTE_CANCELLED':
      return removeKey(state, action.quoteId);

    default:
      return state;
  }
}
